import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'; // Activa Tailwind
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

// Protección global contra crashes de React ('removeChild' / 'insertBefore' en 'Node')
// causados por traductores automáticos de navegadores móviles (Chrome/Safari) o extensiones.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

if (Capacitor.isNativePlatform()) {
  try {
    CapacitorUpdater.notifyAppReady();
    console.log("✅ [CAPGO] notifyAppReady llamado correctamente");
  } catch (e) {
    console.warn("⚠️ [CAPGO] Error al llamar notifyAppReady:", e);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Wrap App with BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);